import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'

type TTermosDaPropostaProps = {
  termos: string
  assinaturaContrato: string
  className?: string
}

const TermosDaProposta = ({ termos, assinaturaContrato, className }: TTermosDaPropostaProps) => {
  const { t } = useTranslation()
  const texto = t(termos, { assinaturaContrato, defaultValue: termos })
  const linhas = texto
    .split('**')
    .filter(Boolean)
    .map((linha) => <li key={linha}>{linha.trim()}</li>)

  return <ul className={twMerge('ml-2 list-disc space-y-4 pl-5', className)}>{linhas}</ul>
}

export { TermosDaProposta }
